// ApiServiceContext.tsx
import React, {createContext, ReactNode, useContext, useMemo} from 'react'; // Added useMemo
import {useDispatch} from 'react-redux';
import {ApiService} from "../services/api";
import StatsLogger from '../services/statsLogger'; // Import StatsLogger


// Create the context
const ApiServiceContext = createContext<ApiService | undefined>(undefined);
const StatsLoggerContext = createContext<StatsLogger | undefined>(undefined);

// Provider component
export const ApiServiceProvider = ({children}: { children: ReactNode }) => {
    const dispatch = useDispatch();
    // Use useMemo to ensure instances are created only once
    const apiServiceInstance = useMemo(() => ApiService.getInstance(dispatch), [dispatch]);
    const statsLoggerInstance = useMemo(() => new StatsLogger(apiServiceInstance), [apiServiceInstance]);

    return (
        <ApiServiceContext.Provider value={apiServiceInstance}>
            <StatsLoggerContext.Provider value={statsLoggerInstance}>
                {children}
            </StatsLoggerContext.Provider>
        </ApiServiceContext.Provider>
    );
};

// Hook to use the context
export const useApiService = (): ApiService => { // Return the full context type
    const context = useContext(ApiServiceContext);
    if (!context) {
        throw new Error('useApiService must be used within an ApiServiceProvider');
    }
    return context;
};

// Hook to use the context
export const useStatsLogger = (): StatsLogger => { // Return the full context type
    const context = useContext(StatsLoggerContext);
    if (!context) {
        throw new Error('useStatsLogger must be used within an StatsLoggerProvider');
    }
    return context;
};